import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { IdentifierTypeViewModel } from '../../../models/Entities/Person/IdentifierType/IdentifierTypeModels';

// store
import * as IdentifierTypesStore from '../../../redux/middleware/PersonIdentifierTypes.Middleware';

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  identifierTypeId?: number | undefined;
}

interface ConnectedProps {
  isAdding: boolean | undefined;
  successAdding: boolean | undefined;
  failAdding: boolean | undefined;
  isUpdating: boolean | undefined;
  successUpdating: boolean | undefined;
  failUpdating: boolean | undefined;
  error: ErrorType | undefined;
  identifierType?: IdentifierTypeViewModel;
}

interface DispatchProps {
  CreateIdentifierType: typeof IdentifierTypesStore.actionCreators.CreateIdentifierType;
  UpdateIdentifierType: typeof IdentifierTypesStore.actionCreators.UpdateIdentifierType;
  GetIdentifierTypes: typeof IdentifierTypesStore.actionCreators.GetIdentifierTypes;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isAdding: state.PersonIdentifierTypes?.isAddingNewOne,
  successAdding: state.PersonIdentifierTypes?.successAddingNewOne,
  failAdding: state.PersonIdentifierTypes?.failOnAddingNewOne,
  isUpdating: state.PersonIdentifierTypes?.isUpdatingOne,
  successUpdating: state.PersonIdentifierTypes?.successUpdatingOne,
  failUpdating: state.PersonIdentifierTypes?.failOnUpdatingOne,
  error: state.PersonIdentifierTypes?.error,
  identifierType: state.PersonIdentifierTypes?.list.find(
    (item: IdentifierTypeViewModel) => item.id === ownProps.identifierTypeId
  ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...IdentifierTypesStore.actionCreators
};
